import React from 'react';

import { Theme } from '../../../../stores/types/themes';



interface Props {
	theme: Theme | null,
}

export default function EditThemeFontTab(props: Props) {


	return (<div className='edit-theme-swatches'>
		Fonts
	</div>);
}
